import { useContext } from "react";

import { LandingTitleContext } from "../../../../../../common/context/landingTitle";
import { ProductContext } from "../../../../../context/product";

export const useTitle = () => {
  const { product } = useContext(ProductContext);
  const { title } = useContext(LandingTitleContext);
  if (Boolean(title)) {
    return title;
  }
  return product ? product.name : "";
};
